// REACT IMPORTS
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MenuList } from "../../data/NavbarMenuList";
import hamburger from "../../assets/media/icons/menu.svg";
import logo from "../../assets/media/logos/Dwinity Logo horizontal black.svg";
import hamburger_dark from "../../assets/media/icons/menu-white.svg";
import logo_dark from "../../assets/media/logos/Dwinity Logo horizontal black.svg";
import search from "../../assets/media/icons/search-dark.svg";
import { SelectedWallet } from "../../walletprovider/components/SelectedWallet";
import { AppContext } from "../../AppContextProvider";
import { useWalletProvider } from "../../walletprovider/useWalletProvider";
import SideNavComponent from "./SideNavComponent";
import SideNavComponentLoginPage from "./SideNavComponentLoginPage";
import AccountBalanceComponent from "./components/AccountBalanceComponent";
import EmailModal from "../../modals/EmailModal";
import ChatModal from "../../modals/ChatModal";
import { WarningTicket, InformationsTicket, NotificationsTicket, ErrorTicket } from "../../components/TicketsComponent";

import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBBtn,
  MDBRow,
  MDBCol,
  MDBSideNav,
  MDBSideNavMenu,
  MDBPopover,
  MDBPopoverBody,
} from "mdb-react-ui-kit";

import { DASHBOARD_PAGE, LOGIN_PAGE_URL, FILES_PAGE } from "../../data/pages";

import { WalletProviderContext } from "../../walletprovider/WalletProvider";
import { DwMpcWalletBackendProviderContext } from "../../mpcwalletprovider/DwMpcWalletBackendProvider";
import { AvatarProviderContext } from "../../provider/AvatarProvider";

const FlagGB = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" width="24" height="12">
    <clipPath id="s">
      <path d="M0,0 v30 h60 v-30 z" />
    </clipPath>
    <clipPath id="t">
      <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
    </clipPath>
    <g clipPath="url(#s)">
      <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </g>
  </svg>
);

const FlagDE = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 3" width="24" height="14">
    <rect width="5" height="3" y="0" fill="#000" />
    <rect width="5" height="2" y="1" fill="#D00" />
    <rect width="5" height="1" y="2" fill="#FFCE00" />
  </svg>
);

const languages = [
  { code: "en", name: "English", Flag: FlagGB },
  { code: "de", name: "Deutsch", Flag: FlagDE },
];

const Header = ({ props, className = "" }) => {
  const { i18n, t } = useTranslation();
  const context = useContext(AppContext);
  const navigate = useNavigate();
  const { selectedAccount } = useContext(WalletProviderContext);

  const currentLanguage = languages.find((lang) => lang.code === i18n.resolvedLanguage) || languages[0];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };
  const { selectedWallet } = useWalletProvider();
  const [openBasic, setOpenBasic] = useState(false);
  const [basicOpen, setBasicOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [preview, setPreview] = useState();
  const [navbarShrunk, setNavbarShrunk] = useState(false);
  const [isDark, setIsDark] = useState(true);
  const [status, setStatus] = useState("");
  const [isErrorTicket, setIsErrorTicket] = useState(false);
  const [errortext, setErrortext] = useState(undefined);
  const [isHeaderChatOpen, setIsHeaderChatOpen] = useState(false);

  const walletContext = useContext(WalletProviderContext);
  const { isConnected } = useContext(WalletProviderContext);

  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
  const { getAvatarAsBase64, setAvatar } = useContext(AvatarProviderContext);

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  const loadData = async () => {
    try {
      const photo = await getAvatarAsBase64(selectedWallet.provider);
      if (photo) {
        setPreview(photo);
      }
    } catch (error) {
      // We don't want to display error
      //console.log(error);
    }
  };

  /* const getAvatarTest = async () => {
    if (selectedAccount !== null) {
      const image = await getAvatar();
      const imageUrl = URL.createObjectURL(image);
      if (imageUrl) {
        setPreview(imageUrl);
      }
    } else {
      setStatus("selectedAccount is null");
    }
  };*/

  const scrollEventListener = () => {
    setNavbarShrunk(window.scrollY < 50 ? false : true);
  };

  useEffect(() => {
    if (storageProps.loaded && selectedWallet) {
      loadData();
    }
    setOpenBasic(false);
    setTimeout(() => {
      setOpenBasic(true);
    }, 500);
  }, [isConnected(), selectedWallet, storageProps.loaded, context.getState()?.isRender]);

  useEffect(() => {
    document.addEventListener("scroll", scrollEventListener);
    return () => {
      document.removeEventListener("scroll", scrollEventListener);
    };
  }, []);

  return (
    <header className={`${navbarShrunk ? "header padding-top" : "header"}${className ? ` ${className}` : ""}`}>
      <MDBContainer fluid className="p-0">
        <MDBNavbar expand="lg" className="d-none d-lg-flex">
          <div className="block">
            <MDBNavbarBrand href="#">
              <div
                onClick={() => {
                  navigate(FILES_PAGE.url);
                  props?.setBasicOpen?.();
                }}
                style={{ display: "flex", alignItems: "center", gap: 10 }}
              >
                {/*<img src={!isDark ? logo : logo_dark} alt="logo" />*/}
                <svg width="96" height="36" viewBox="0 0 96 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22.5 24.7606C22.5 30.9677 17.6013 36 11.559 36C10.803 36 10.0659 35.9187 9.353 35.7674C10.6753 35.441 11.6569 34.2189 11.6569 32.7617C11.6569 31.5542 10.9838 30.5093 10.0027 30.0002C10.4953 30.1541 11.0177 30.238 11.559 30.238C14.5037 30.238 16.8897 27.7865 16.8897 24.7606C16.8897 22.7774 15.8633 21.0415 14.3271 20.0809C15.8277 19.782 16.96 18.4262 16.96 16.7978C16.96 15.8539 16.5791 15.0008 15.9658 14.3923C17.0056 13.4192 17.4991 11.5952 17.4991 9.06632V9.01816C17.5247 8.93517 17.4941 8.85863 17.4991 8.80015V8.7077C17.4991 7.17818 17.5469 6.48028 17.5469 5.09868C17.5469 -1.71343 22.456 0.268026 22.456 0.268026C22.456 0.268026 22.4866 20.2799 22.4933 24.4346C22.4962 24.5439 22.5 24.6514 22.5 24.7606ZM14.055 14.2698L7.34797 11.7629L7.3283 11.7564C6.10435 11.2976 4.75105 11.9461 4.30484 13.2042C3.85862 14.4616 4.48985 15.8522 5.71506 16.3089L5.73515 16.3157L5.73348 16.3175L12.4418 18.8244C12.456 18.8304 12.4711 18.836 12.4857 18.842C13.7097 19.2991 15.0642 18.6515 15.5087 17.3933C15.9554 16.136 15.3246 14.7445 14.1002 14.2874C14.0843 14.2818 14.0696 14.2767 14.055 14.2724V14.2698ZM10.3463 19.1219L3.6397 16.6137H3.63845L3.61961 16.6064C2.39524 16.1485 1.04111 16.7969 0.596153 18.0542C0.149939 19.3124 0.781587 20.7031 2.00554 21.161C2.01223 21.1645 2.01893 21.1649 2.02563 21.1675L8.73266 23.6761L8.73308 23.6752C8.74773 23.6804 8.76238 23.6873 8.77828 23.6929C10.0018 24.1508 11.3555 23.5024 11.8005 22.2442C12.2463 20.986 11.6159 19.5962 10.3915 19.1387C10.3764 19.1327 10.361 19.1275 10.3455 19.1224L10.3463 19.1219ZM8.56899 24.6948C8.5828 24.7008 8.59662 24.7051 8.60959 24.7103C9.70587 25.1201 10.271 26.3645 9.87247 27.4915C9.4723 28.6173 8.26175 29.1982 7.16505 28.7876C7.15165 28.7824 7.13826 28.7768 7.12528 28.7708V28.7725L1.40821 26.635L1.39021 26.6285C0.294352 26.2191 -0.270323 24.9739 0.127335 23.8468C0.527086 22.7215 1.7389 22.1401 2.83476 22.5508L2.85276 22.5577L8.56983 24.6948H8.56899ZM8.99344 30.5514L4.74435 28.9621L4.72719 28.9557C3.63008 28.5459 2.41868 29.126 2.01977 30.2521C1.62086 31.3792 2.18553 32.624 3.28139 33.0338L3.29939 33.039V33.0407L7.54889 34.6296V34.6279C7.56187 34.633 7.57526 34.6386 7.58908 34.6446C8.68536 35.0536 9.89675 34.4735 10.2957 33.3473C10.695 32.2207 10.1299 30.9771 9.03404 30.5665C9.02023 30.5605 9.00641 30.5562 8.99344 30.5527V30.5514Z"
                    fill="#ffffff"
                  />
                  <path
                    d="M38.2336 25.0795C37.5989 26.1677 36.2063 26.5329 35.1215 25.8954C34.0384 25.2579 33.6745 23.8602 34.3086 22.7721C34.9438 21.685 36.3381 21.3193 37.4212 21.9557C38.5049 22.5931 38.8693 23.993 38.2336 25.0795ZM41.0401 13.5012H40.669C39.7888 13.4747 38.5324 13.8759 38.5341 16.418V19.7303C36.277 18.4841 33.4648 19.2633 32.1552 21.505C30.8231 23.7877 31.5867 26.7214 33.8606 28.0577C36.1346 29.3951 39.0566 28.6271 40.3886 26.3455C40.8001 25.6405 41.0115 24.8719 41.0401 24.1106C41.0541 24.0971 41.0625 24.0909 41.0625 24.0909L41.0401 13.5012ZM91.183 31.5H88.1646L89.5454 28.2405L86.1716 19.6038H89.0919L91.1634 25.2292L93.1425 19.6038H96L91.183 31.5ZM85.3525 21.4948H82.7584V24.5855C82.7584 24.8899 82.7595 25.1555 82.7674 25.3839C82.7708 25.6118 82.8111 25.816 82.8896 25.9961C82.9608 26.1778 83.087 26.3219 83.2697 26.4271C83.4514 26.5334 83.7188 26.5874 84.0669 26.5874C84.2116 26.5874 84.4 26.5559 84.6321 26.494C84.8653 26.4327 85.0296 26.3753 85.1215 26.3236H85.3525V28.2304C85.0536 28.3086 84.7369 28.3677 84.4033 28.4116C84.0692 28.4566 83.6599 28.478 83.1755 28.478C82.0952 28.478 81.289 28.258 80.7626 27.8197C80.2345 27.3797 79.9715 26.628 79.9715 25.5645V21.4948H78.8273V19.6038H79.9715V17.1168H82.7584V19.6038H85.3525V21.4948ZM77.2682 18.3642H74.3248V16.2486H77.2682V18.3642ZM77.1897 28.3075H74.4028V19.6038H77.1897V28.3075ZM72.0873 28.3075H69.2982V23.9908C69.2982 23.6391 69.2808 23.2897 69.2449 22.9414C69.2096 22.592 69.1474 22.3349 69.0599 22.17C68.9545 21.9776 68.8054 21.8381 68.6086 21.7508C68.409 21.6631 68.1332 21.6181 67.7772 21.6181C67.5255 21.6181 67.2693 21.6597 67.0097 21.7435C66.7501 21.8257 66.467 21.9579 66.1637 22.1391V28.3075H63.3768V19.6038H66.1637V20.5642C66.6571 20.1777 67.1325 19.8806 67.5872 19.6741C68.0413 19.4676 68.5464 19.3641 69.1014 19.3641C70.0388 19.3641 70.7687 19.6381 71.2957 20.185C71.8233 20.7336 72.0873 21.5522 72.0873 22.641V28.3075ZM61.229 18.3642H58.2868V16.2486H61.229V18.3642ZM61.1528 28.3075H58.3636V19.6038H61.1528V28.3075ZM54.3327 28.3075H51.3821L49.6144 22.4412L47.8692 28.3075H44.8883L42.2247 19.6038H45.1411L46.6296 25.6028L48.4791 19.6038H50.9442L52.7024 25.6028L54.1667 19.6038H57.0198L54.3327 28.3075Z"
                    fill="#ffffff"
                  />
                </svg>
              </div>
            </MDBNavbarBrand>
          </div>
          {/*context.getState()?.isLoaded && (
            <div className="info-button">
              <button className="button subtle large" onClick={() => context.openModal("centralinfo", "")}>
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.875 17.5C9.70924 17.5 9.55027 17.4342 9.43306 17.3169C9.31585 17.1997 9.25 17.0408 9.25 16.875V15H6.125C5.29555 14.998 4.50075 14.6671 3.91493 14.0799C3.3291 13.4927 3.00007 12.6971 3 11.8677V5.63232C2.99951 4.80313 3.32802 4.00762 3.91342 3.42037C4.49883 2.83312 5.29331 2.50212 6.1225 2.5H14.8775C15.7066 2.50232 16.501 2.83339 17.0864 3.42059C17.6717 4.0078 18.0003 4.80319 18 5.63232V11.8677C17.9999 12.6973 17.6706 13.493 17.0845 14.0803C16.4985 14.6675 15.7034 14.9982 14.8737 15H12.6337L10.3169 17.3169C10.2589 17.3749 10.19 17.421 10.1142 17.4524C10.0383 17.4838 9.95707 17.5 9.875 17.5V17.5ZM6.1225 3.75C5.62477 3.7519 5.14811 3.95114 4.79707 4.30402C4.44604 4.65689 4.2493 5.13459 4.25 5.63232V11.8677C4.24965 12.3657 4.44685 12.8436 4.79835 13.1965C5.14984 13.5493 5.62694 13.7484 6.125 13.75H9.875C9.95709 13.7499 10.0384 13.7661 10.1142 13.7975C10.1901 13.8289 10.259 13.8749 10.3171 13.9329C10.3751 13.991 10.4211 14.0599 10.4525 14.1358C10.4839 14.2116 10.5001 14.2929 10.5 14.375V15.3663L11.9331 13.9331C11.9911 13.875 12.06 13.829 12.1358 13.7976C12.2116 13.7661 12.2929 13.75 12.375 13.75H14.8737C15.372 13.7487 15.8494 13.5497 16.2011 13.1968C16.5529 12.844 16.7503 12.3659 16.75 11.8677V5.63232C16.7534 5.38501 16.7074 5.13951 16.6147 4.91022C16.5219 4.68094 16.3843 4.47251 16.2098 4.29716C16.0354 4.12181 15.8277 3.98308 15.5989 3.88912C15.3701 3.79516 15.1248 3.74786 14.8775 3.75H6.1225ZM15.5 5.625C15.5 5.54291 15.4839 5.46161 15.4525 5.38576C15.4211 5.30991 15.3751 5.24099 15.3171 5.18294C15.259 5.1249 15.1901 5.07886 15.1142 5.04747C15.0384 5.01608 14.9571 4.99995 14.875 5H6.125C5.95924 5 5.80027 5.06585 5.68306 5.18306C5.56585 5.30027 5.5 5.45924 5.5 5.625C5.5 5.79076 5.56585 5.94973 5.68306 6.06694C5.80027 6.18415 5.95924 6.25 6.125 6.25H14.875C14.9571 6.25005 15.0384 6.23392 15.1142 6.20253C15.1901 6.17114 15.259 6.1251 15.3171 6.06706C15.3751 6.00901 15.4211 5.94009 15.4525 5.86424C15.4839 5.78839 15.5 5.70709 15.5 5.625V5.625ZM13 8.125C13 8.04291 12.9839 7.96161 12.9525 7.88576C12.9211 7.80991 12.8751 7.74099 12.8171 7.68294C12.759 7.6249 12.6901 7.57886 12.6142 7.54747C12.5384 7.51608 12.4571 7.49995 12.375 7.5H6.125C5.95924 7.5 5.80027 7.56585 5.68306 7.68306C5.56585 7.80027 5.5 7.95924 5.5 8.125C5.5 8.29076 5.56585 8.44973 5.68306 8.56694C5.80027 8.68415 5.95924 8.75 6.125 8.75H12.375C12.4571 8.75005 12.5384 8.73392 12.6142 8.70253C12.6901 8.67114 12.759 8.6251 12.8171 8.56706C12.8751 8.50901 12.9211 8.44009 12.9525 8.36424C12.9839 8.28839 13 8.20709 13 8.125V8.125ZM14.25 10.625C14.25 10.5429 14.2339 10.4616 14.2025 10.3858C14.1711 10.3099 14.1251 10.241 14.0671 10.1829C14.009 10.1249 13.9401 10.0789 13.8642 10.0475C13.7884 10.0161 13.7071 9.99995 13.625 10H6.125C5.95924 10 5.80027 10.0658 5.68306 10.1831C5.56585 10.3003 5.5 10.4592 5.5 10.625C5.5 10.7908 5.56585 10.9497 5.68306 11.0669C5.80027 11.1842 5.95924 11.25 6.125 11.25H13.625C13.7071 11.2501 13.7884 11.2339 13.8642 11.2025C13.9401 11.1711 14.009 11.1251 14.0671 11.0671C14.1251 11.009 14.1711 10.9401 14.2025 10.8642C14.2339 10.7884 14.25 10.7071 14.25 10.625V10.625Z"
                    fill="var(--text-brand-tertiary)"
                  />
                </svg>
                <span className="text">Join us on Discord – Find invite link here in our release note.</span>
              </button>
            </div>
          )*/}

          <MDBNavbarNav className="mr-auto mb-2 mb-lg-0 navigation-pill-list">
            <MDBNavbarItem className="navigation-pill">
              <MDBDropdown className="header-dorpdown">
                <MDBDropdownToggle
                  tag="a"
                  className="nav-link"
                  style={{ height: "100%", position: "relative", display: "flex", alignItems: "center", gap: "4px" }}
                  role="button"
                  aria-label={t("header.language.selectLanguage")}
                >
                  <currentLanguage.Flag />
                </MDBDropdownToggle>
                <MDBDropdownMenu>
                  {languages.map((lang) => (
                    <MDBDropdownItem
                      key={lang.code}
                      link
                      onClick={() => handleLanguageChange(lang.code)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        fontWeight: lang.code === currentLanguage.code ? "bold" : "normal",
                        color: "#ffffff",
                        padding: "8px 16px",
                      }}
                      className="language-dropdown-item"
                    >
                      <lang.Flag />
                      <span>{lang.name}</span>
                    </MDBDropdownItem>
                  ))}
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavbarItem>
            {isConnected() && (
              <>
                {/*<MDBNavbarItem className="navigation-pill me-3">
                  <MDBPopover
                    btnClassName="button brand large dwin"
                    btnChildren={
                      <div className="text p18x" style={{ textTransform: "full-size-kana" }}>
                        Buy DWIN
                      </div>
                    }
                    placement="bottom"
                    dismiss
                  >
                    <MDBPopoverBody>
                      This button is for demonstration purposes only and is currently under development.
                    </MDBPopoverBody>
                  </MDBPopover>
                </MDBNavbarItem>*/}
                {/*context.getState()?.isProgress && (
                  <div className="proggress-div-header">
                    <div className="left-div">
                      <progress id="progress-bar-completed" value="0" max="100"></progress>
                      <label htmlFor="progress-bar-completed">0%</label>
                    </div>
                  </div>
                )*/}
                <AccountBalanceComponent />
                {/*<MDBNavbarItem className="navigation-pill" onClick={() => console.log("search")}>
                  <MDBNavbarLink aria-current="page" href="#" className="navbar-text">
                    <img src={search} alt="search" height="30" />
                  </MDBNavbarLink>
                </MDBNavbarItem>*/}
                <MDBNavbarItem className="navigation-pill">
                  <MDBDropdown className="header-dorpdown">
                    <MDBDropdownToggle
                      tag="a"
                      className="nav-link"
                      style={{ height: "100%", position: "relative" }}
                      role="button"
                    >
                      <div className="editable-username-header">
                        <div className="profile">
                          <div className="overlap-group">
                            {preview ? (
                              <img src={preview} className="user-profile" alt="" />
                            ) : (
                              <svg
                                width="36"
                                height="36"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="user-profile"
                                style={{ color: "#b0b0c0" }}
                              >
                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none" />
                                <circle cx="12" cy="9" r="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
                                <path
                                  d="M5.5 19.5C6.5 16.5 9 15 12 15C15 15 17.5 16.5 18.5 19.5"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  fill="none"
                                />
                              </svg>
                            )}
                          </div>
                        </div>
                      </div>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="header-user-dropdown-menu">
                      <MDBDropdownItem link>{openBasic && isConnected() && <SelectedWallet />}</MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavbarItem>
              </>
            )}
          </MDBNavbarNav>
        </MDBNavbar>
        <div className=" d-block d-lg-none" style={{ marginTop: "-5px" }}>
          <div className="navigation-pill-respo">
            <div style={{ display: "flex", alignItems: "flex-end" }}>
              {/*<img src={!isDark ? logo : logo_dark} alt="logo" />*/}
              <svg width="96" height="36" viewBox="0 0 96 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M22.5 24.7606C22.5 30.9677 17.6013 36 11.559 36C10.803 36 10.0659 35.9187 9.353 35.7674C10.6753 35.441 11.6569 34.2189 11.6569 32.7617C11.6569 31.5542 10.9838 30.5093 10.0027 30.0002C10.4953 30.1541 11.0177 30.238 11.559 30.238C14.5037 30.238 16.8897 27.7865 16.8897 24.7606C16.8897 22.7774 15.8633 21.0415 14.3271 20.0809C15.8277 19.782 16.96 18.4262 16.96 16.7978C16.96 15.8539 16.5791 15.0008 15.9658 14.3923C17.0056 13.4192 17.4991 11.5952 17.4991 9.06632V9.01816C17.5247 8.93517 17.4941 8.85863 17.4991 8.80015V8.7077C17.4991 7.17818 17.5469 6.48028 17.5469 5.09868C17.5469 -1.71343 22.456 0.268026 22.456 0.268026C22.456 0.268026 22.4866 20.2799 22.4933 24.4346C22.4962 24.5439 22.5 24.6514 22.5 24.7606ZM14.055 14.2698L7.34797 11.7629L7.3283 11.7564C6.10435 11.2976 4.75105 11.9461 4.30484 13.2042C3.85862 14.4616 4.48985 15.8522 5.71506 16.3089L5.73515 16.3157L5.73348 16.3175L12.4418 18.8244C12.456 18.8304 12.4711 18.836 12.4857 18.842C13.7097 19.2991 15.0642 18.6515 15.5087 17.3933C15.9554 16.136 15.3246 14.7445 14.1002 14.2874C14.0843 14.2818 14.0696 14.2767 14.055 14.2724V14.2698ZM10.3463 19.1219L3.6397 16.6137H3.63845L3.61961 16.6064C2.39524 16.1485 1.04111 16.7969 0.596153 18.0542C0.149939 19.3124 0.781587 20.7031 2.00554 21.161C2.01223 21.1645 2.01893 21.1649 2.02563 21.1675L8.73266 23.6761L8.73308 23.6752C8.74773 23.6804 8.76238 23.6873 8.77828 23.6929C10.0018 24.1508 11.3555 23.5024 11.8005 22.2442C12.2463 20.986 11.6159 19.5962 10.3915 19.1387C10.3764 19.1327 10.361 19.1275 10.3455 19.1224L10.3463 19.1219ZM8.56899 24.6948C8.5828 24.7008 8.59662 24.7051 8.60959 24.7103C9.70587 25.1201 10.271 26.3645 9.87247 27.4915C9.4723 28.6173 8.26175 29.1982 7.16505 28.7876C7.15165 28.7824 7.13826 28.7768 7.12528 28.7708V28.7725L1.40821 26.635L1.39021 26.6285C0.294352 26.2191 -0.270323 24.9739 0.127335 23.8468C0.527086 22.7215 1.7389 22.1401 2.83476 22.5508L2.85276 22.5577L8.56983 24.6948H8.56899ZM8.99344 30.5514L4.74435 28.9621L4.72719 28.9557C3.63008 28.5459 2.41868 29.126 2.01977 30.2521C1.62086 31.3792 2.18553 32.624 3.28139 33.0338L3.29939 33.039V33.0407L7.54889 34.6296V34.6279C7.56187 34.633 7.57526 34.6386 7.58908 34.6446C8.68536 35.0536 9.89675 34.4735 10.2957 33.3473C10.695 32.2207 10.1299 30.9771 9.03404 30.5665C9.02023 30.5605 9.00641 30.5562 8.99344 30.5527V30.5514Z"
                  fill="#ffffff"
                />
                <path
                  d="M38.2336 25.0795C37.5989 26.1677 36.2063 26.5329 35.1215 25.8954C34.0384 25.2579 33.6745 23.8602 34.3086 22.7721C34.9438 21.685 36.3381 21.3193 37.4212 21.9557C38.5049 22.5931 38.8693 23.993 38.2336 25.0795ZM41.0401 13.5012H40.669C39.7888 13.4747 38.5324 13.8759 38.5341 16.418V19.7303C36.277 18.4841 33.4648 19.2633 32.1552 21.505C30.8231 23.7877 31.5867 26.7214 33.8606 28.0577C36.1346 29.3951 39.0566 28.6271 40.3886 26.3455C40.8001 25.6405 41.0115 24.8719 41.0401 24.1106C41.0541 24.0971 41.0625 24.0909 41.0625 24.0909L41.0401 13.5012ZM91.183 31.5H88.1646L89.5454 28.2405L86.1716 19.6038H89.0919L91.1634 25.2292L93.1425 19.6038H96L91.183 31.5ZM85.3525 21.4948H82.7584V24.5855C82.7584 24.8899 82.7595 25.1555 82.7674 25.3839C82.7708 25.6118 82.8111 25.816 82.8896 25.9961C82.9608 26.1778 83.087 26.3219 83.2697 26.4271C83.4514 26.5334 83.7188 26.5874 84.0669 26.5874C84.2116 26.5874 84.4 26.5559 84.6321 26.494C84.8653 26.4327 85.0296 26.3753 85.1215 26.3236H85.3525V28.2304C85.0536 28.3086 84.7369 28.3677 84.4033 28.4116C84.0692 28.4566 83.6599 28.478 83.1755 28.478C82.0952 28.478 81.289 28.258 80.7626 27.8197C80.2345 27.3797 79.9715 26.628 79.9715 25.5645V21.4948H78.8273V19.6038H79.9715V17.1168H82.7584V19.6038H85.3525V21.4948ZM77.2682 18.3642H74.3248V16.2486H77.2682V18.3642ZM77.1897 28.3075H74.4028V19.6038H77.1897V28.3075ZM72.0873 28.3075H69.2982V23.9908C69.2982 23.6391 69.2808 23.2897 69.2449 22.9414C69.2096 22.592 69.1474 22.3349 69.0599 22.17C68.9545 21.9776 68.8054 21.8381 68.6086 21.7508C68.409 21.6631 68.1332 21.6181 67.7772 21.6181C67.5255 21.6181 67.2693 21.6597 67.0097 21.7435C66.7501 21.8257 66.467 21.9579 66.1637 22.1391V28.3075H63.3768V19.6038H66.1637V20.5642C66.6571 20.1777 67.1325 19.8806 67.5872 19.6741C68.0413 19.4676 68.5464 19.3641 69.1014 19.3641C70.0388 19.3641 70.7687 19.6381 71.2957 20.185C71.8233 20.7336 72.0873 21.5522 72.0873 22.641V28.3075ZM61.229 18.3642H58.2868V16.2486H61.229V18.3642ZM61.1528 28.3075H58.3636V19.6038H61.1528V28.3075ZM54.3327 28.3075H51.3821L49.6144 22.4412L47.8692 28.3075H44.8883L42.2247 19.6038H45.1411L46.6296 25.6028L48.4791 19.6038H50.9442L52.7024 25.6028L54.1667 19.6038H57.0198L54.3327 28.3075Z"
                  fill="#ffffff"
                />
              </svg>
            </div>
            <div className="navigation-pill-respo" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <MDBDropdown className="header-dorpdown">
                <MDBDropdownToggle
                  tag="a"
                  className="nav-link"
                  style={{ height: "100%", position: "relative", display: "flex", alignItems: "center" }}
                  role="button"
                  aria-label={t("header.language.selectLanguage")}
                >
                  <currentLanguage.Flag />
                </MDBDropdownToggle>
                <MDBDropdownMenu>
                  {languages.map((lang) => (
                    <MDBDropdownItem
                      key={lang.code}
                      link
                      onClick={() => handleLanguageChange(lang.code)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        fontWeight: lang.code === currentLanguage.code ? "bold" : "normal",
                        color: "#ffffff",
                        padding: "8px 16px",
                      }}
                      className="language-dropdown-item"
                    >
                      <lang.Flag />
                      <span>{lang.name}</span>
                    </MDBDropdownItem>
                  ))}
                </MDBDropdownMenu>
              </MDBDropdown>
              <MDBDropdown className="header-dorpdown">
                <MDBDropdownToggle
                  tag="a"
                  className="nav-link"
                  style={{ height: "100%", position: "relative" }}
                  role="button"
                  onClick={() => setBasicOpen(false)}
                >
                  <div className="editable-username-header">
                    <div className="profile">
                      <div className="overlap-group">
                        {preview ? (
                          <img src={preview} className="user-profile" alt="" />
                        ) : (
                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="user-profile"
                            style={{ color: "#b0b0c0" }}
                          >
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none" />
                            <circle cx="12" cy="9" r="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
                            <path
                              d="M5.5 19.5C6.5 16.5 9 15 12 15C15 15 17.5 16.5 18.5 19.5"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              fill="none"
                            />
                          </svg>
                        )}
                      </div>
                    </div>
                  </div>
                </MDBDropdownToggle>
                <MDBDropdownMenu className="header-user-dropdown-menu" style={{ display: "flex", flexDirection: "column" }}>
                  <MDBDropdownItem link>{openBasic && isConnected() && <SelectedWallet />}</MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </div>
          </div>

          <MDBSideNav
            isOpen={basicOpen}
            absolute
            left="true"
            getOpenState={(e) => setBasicOpen(e)}
            className={context.getState()?.displayMode === "light" ? "" : "dark"}
          >
            <MDBSideNavMenu>
              {!isConnected() && <SideNavComponentLoginPage setBasicOpen={() => setBasicOpen(!basicOpen)} />}
              {isConnected() && <SideNavComponent setBasicOpen={() => setBasicOpen(!basicOpen)} />}
            </MDBSideNavMenu>
          </MDBSideNav>
        </div>
      </MDBContainer>
      {openModal && <EmailModal visible={openModal} handleClose={() => setOpenModal(false)} />}
      <div className="ticket-div">
        {isErrorTicket && (
          <>
            <ErrorTicket
              close={() => {
                setIsErrorTicket(false);
                props.refreshGraph();
              }}
              text={errortext}
            />
            <div style={{ height: "20px" }} />
          </>
        )}
      </div>

      <ChatModal
        isOpen={isHeaderChatOpen}
        onClose={() => setIsHeaderChatOpen(false)}
        walletAddress={selectedAccount}
        provider={selectedWallet?.provider || null}
      />
    </header>
  );
};

export default Header;
